import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/Button';
import { ALLIANCE_STATUS_LABELS, isNegativeStatus } from '../constants/status';

interface StatusChangeConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  candidateName: string;
  agentName: string;
  status: string;
  isSubmitting?: boolean;
}

export default function StatusChangeConfirmModal({
  open,
  onClose,
  onConfirm,
  candidateName,
  agentName,
  status,
  isSubmitting = false,
}: StatusChangeConfirmModalProps) {
  const label = ALLIANCE_STATUS_LABELS[status] ?? '';
  const negative = isNegativeStatus(status);

  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          onClose();
        }
      }}
    >
      <DialogContent className="w-[620px] rounded">
        <DialogHeader className="items-start space-y-0 px-lg! py-md!">
          <DialogTitle className="text-base font-bold">選考ステータスの更新</DialogTitle>
        </DialogHeader>

        <div className="flex flex-col p-lg text-body-sm">
          <p>
            {candidateName}さんのステータスを「{label}」に
            {negative ? 'しますか？' : '更新しますか？'}
          </p>
          <p>更新すると、{agentName}にメールで通知されます。</p>
        </div>

        <DialogFooter className="justify-end gap-md px-lg! py-md!">
          <Button color="secondary" size="md" onClick={onClose} disabled={isSubmitting}>
            キャンセル
          </Button>
          <Button
            color={negative ? 'danger' : 'primary'}
            size="md"
            onClick={onConfirm}
            disabled={isSubmitting}
          >
            {negative ? `${label}にする` : '更新する'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
